<template>
  <!-- 设备工况 -->
  <div style="width: 100%;height: 100%;margin: auto;" id="Rectangulartree">
  </div>
</template>
<script>
  import * as echarts from 'echarts';
 import {
    getChannelTypes,
    getEquipsCondition,
    GetSheBeiGongKuangRectangleList,
  } from '@/api/equipments/equipments';
  export default {
    name: 'equipments-condition',
    components: {
    },
    data() {
      return {
      };
    },
    watch: {
    },
    created() {
      this.Verifylogin();
    },
    mounted() {
      this.deviceDetails();
    },
    computed: {
    },
    methods: {
      Verifylogin(){
        var userinfo = JSON.parse(localStorage.getItem('userInfo'));
        if(userinfo == null || userinfo == undefined || userinfo == ""){
          this.$router.push({
              name: "Login",
              params:{type:2}   // 声音跳转到登录页的类型，如果为2则为登录页跳转设备工况详情页面
            });
        }
      },
      deviceDetails() {
        GetSheBeiGongKuangRectangleList({})
          .then((res) => {
            let demoData = res.list;
            this.initChart(demoData);
          })
          .catch(() => {
            // this.initChart( );
          });
      },
      initChart(demoData) {
        this.$nextTick(() => {
          let myChart = echarts.init(document.getElementById('Rectangulartree'));
          let option;
          myChart.setOption(
            (option = {
              title: {
                text: '',
                left: 'center'
              },
              tooltip: {
                formatter: function (info) {
                  var value = info.value;
                  var treePathInfo = info.treePathInfo;
                  var treePath = [];
                  for (var i = 1; i < treePathInfo.length; i++) {
                    treePath.push(treePathInfo[i].name);
                  }
                  return [
                    '<div class="tooltip-title">' +
                    formatUtil.encodeHTML(treePath.join('/')) +
                    '</div>',
                    'Disk Usage: ' + formatUtil.addCommas(value) + 'KB'
                  ].join('');
                }
              },
              series: [
                {
                  name: '复位',
                  type: 'treemap',
                  visibleMin: 300,
                  label: {
                    show: true,
                    formatter: '{b}'
                  },
                  itemStyle: {
                    borderColor: '#fff'
                  },
                  levels: this.getLevelOption(),
                  data: demoData
                }
              ]
            })
          );
          myChart.setOption(option);
        })
      },
      getLevelOption() {
        return [
          {
            itemStyle: {
              borderWidth: 0,
              gapWidth: 5
            }
          },
          {
            itemStyle: {
              gapWidth: 1
            }
          },
          {
            colorSaturation: [0.35, 0.5],
            itemStyle: {
              gapWidth: 1,
              borderColorSaturation: 0.6
            }
          }
        ];
      },
    },
  };
</script>
<style scoped>

</style>
<style lang="scss" scoped>


</style>